// Banyo & WC Mock Data
// Vitrifiye, armatür, duş kabin, ayna dolap, aksesuar takibi

export const banyoSiparisler = [
    {
        id: 'bn-001', siparisTarihi: '2026-01-10', teslimTarihi: '2026-01-20', tedarikci: 'Vitra',
        tedarikciFirmaId: 'f-060', tur: 'Klozet', model: 'S50 Rim-Ex', renk: 'Beyaz',
        miktar: 16, birim: 'adet', birimFiyat: 4500, toplamFiyat: 72000, durum: 'teslim',
        montajDurumu: 'devam', montajlanan: 8, insaatId: 'c1', blokAdi: 'A Blok',
        not: '1-2-3. kat dairelerine montajlandı', createdAt: '2026-01-10T09:00:00Z', updatedAt: '2026-02-01T14:00:00Z',
    },
    {
        id: 'bn-002', siparisTarihi: '2026-01-10', teslimTarihi: '2026-01-20', tedarikci: 'Vitra',
        tedarikciFirmaId: 'f-060', tur: 'Lavabo', model: 'S50 60cm', renk: 'Beyaz',
        miktar: 24, birim: 'adet', birimFiyat: 2800, toplamFiyat: 67200, durum: 'teslim',
        montajDurumu: 'devam', montajlanan: 12, insaatId: 'c1', blokAdi: 'A Blok',
        not: 'Banyo + WC lavaboları', createdAt: '2026-01-10T09:30:00Z', updatedAt: '2026-02-01T15:00:00Z',
    },
    {
        id: 'bn-003', siparisTarihi: '2026-01-11', teslimTarihi: '2026-01-22', tedarikci: 'Artema',
        tedarikciFirmaId: 'f-061', tur: 'Batarya / Armatür', model: 'Dynamic S Set', renk: 'Krom',
        miktar: 32, birim: 'adet', birimFiyat: 3200, toplamFiyat: 102400, durum: 'teslim',
        montajDurumu: 'devam', montajlanan: 16, insaatId: 'c1', blokAdi: 'A-B Blok',
        not: 'Lavabo + duş bataryaları set', createdAt: '2026-01-11T08:00:00Z', updatedAt: '2026-01-30T11:00:00Z',
    },
    {
        id: 'bn-004', siparisTarihi: '2026-01-12', teslimTarihi: '2026-01-25', tedarikci: 'Çamlıca Cam',
        tedarikciFirmaId: 'f-062', tur: 'Duş Kabin', model: '80x80 Kare', renk: 'Şeffaf/Krom',
        miktar: 8, birim: 'adet', birimFiyat: 8500, toplamFiyat: 68000, durum: 'teslim',
        montajDurumu: 'devam', montajlanan: 4, insaatId: 'c1', blokAdi: 'A Blok',
        not: 'Standart daireler için', createdAt: '2026-01-12T10:00:00Z', updatedAt: '2026-01-28T16:00:00Z',
    },
    {
        id: 'bn-005', siparisTarihi: '2026-01-13', teslimTarihi: '2026-01-24', tedarikci: 'Hilton Banyo',
        tedarikciFirmaId: 'f-063', tur: 'Banyo Dolabı', model: 'Slim 65cm + Ayna', renk: 'Beyaz',
        miktar: 16, birim: 'adet', birimFiyat: 4200, toplamFiyat: 67200, durum: 'teslim',
        montajDurumu: 'devam', montajlanan: 6, insaatId: 'c1', blokAdi: 'A Blok',
        not: 'Ayna dahil set', createdAt: '2026-01-13T09:00:00Z', updatedAt: '2026-01-29T10:00:00Z',
    },
    {
        id: 'bn-006', siparisTarihi: '2026-01-14', teslimTarihi: '2026-01-26', tedarikci: 'Creavit',
        tedarikciFirmaId: 'f-064', tur: 'Aksesuar Seti', model: 'Wing Set (5 Parça)', renk: 'Krom',
        miktar: 16, birim: 'set', birimFiyat: 2200, toplamFiyat: 35200, durum: 'teslim',
        montajDurumu: 'devam', montajlanan: 6, insaatId: 'c1', blokAdi: 'A Blok',
        not: 'Havluluk, sabunluk, kağıtlık, fırçalık, askılık', createdAt: '2026-01-14T11:00:00Z', updatedAt: '2026-01-30T14:00:00Z',
    },
    {
        id: 'bn-007', siparisTarihi: '2026-01-16', teslimTarihi: null, tedarikci: 'Vitra',
        tedarikciFirmaId: 'f-060', tur: 'Klozet', model: 'Integra Rim-Ex', renk: 'Beyaz',
        miktar: 24, birim: 'adet', birimFiyat: 5200, toplamFiyat: 124800, durum: 'bekliyor',
        montajDurumu: 'bekliyor', montajlanan: 0, insaatId: 'c2', blokAdi: 'A-B Blok',
        not: 'Premium seri klozet', createdAt: '2026-01-16T10:00:00Z', updatedAt: '2026-01-16T10:00:00Z',
    },
    {
        id: 'bn-008', siparisTarihi: '2026-01-16', teslimTarihi: null, tedarikci: 'Grohe',
        tedarikciFirmaId: 'f-065', tur: 'Batarya / Armatür', model: 'Eurocosmo Set', renk: 'Krom',
        miktar: 48, birim: 'adet', birimFiyat: 4500, toplamFiyat: 216000, durum: 'bekliyor',
        montajDurumu: 'bekliyor', montajlanan: 0, insaatId: 'c2', blokAdi: 'A-B-C Blok',
        not: 'Tüm dairelerin bataryaları', createdAt: '2026-01-16T11:00:00Z', updatedAt: '2026-01-16T11:00:00Z',
    },
    {
        id: 'bn-009', siparisTarihi: '2026-01-17', teslimTarihi: null, tedarikci: 'Duravit',
        tedarikciFirmaId: 'f-066', tur: 'Lavabo', model: 'ME by Starck 65cm', renk: 'Beyaz',
        miktar: 36, birim: 'adet', birimFiyat: 4800, toplamFiyat: 172800, durum: 'bekliyor',
        montajDurumu: 'bekliyor', montajlanan: 0, insaatId: 'c2', blokAdi: 'A-B-C Blok',
        not: 'Tasarım lavabolar', createdAt: '2026-01-17T09:00:00Z', updatedAt: '2026-01-17T09:00:00Z',
    },
    {
        id: 'bn-010', siparisTarihi: '2026-01-18', teslimTarihi: null, tedarikci: 'Çamlıca Cam',
        tedarikciFirmaId: 'f-062', tur: 'Duş Kabin', model: '90x120 Dikdörtgen', renk: 'Şeffaf/Krom',
        miktar: 12, birim: 'adet', birimFiyat: 12000, toplamFiyat: 144000, durum: 'bekliyor',
        montajDurumu: 'bekliyor', montajlanan: 0, insaatId: 'c2', blokAdi: 'A Blok',
        not: 'Büyük daireler için geniş kabin', createdAt: '2026-01-18T10:00:00Z', updatedAt: '2026-01-18T10:00:00Z',
    },
    {
        id: 'bn-011', siparisTarihi: '2026-01-15', teslimTarihi: '2026-01-27', tedarikci: 'Hilton Banyo',
        tedarikciFirmaId: 'f-063', tur: 'WC Dolabı', model: 'Mini 45cm + Ayna', renk: 'Beyaz',
        miktar: 8, birim: 'adet', birimFiyat: 2800, toplamFiyat: 22400, durum: 'teslim',
        montajDurumu: 'devam', montajlanan: 4, insaatId: 'c1', blokAdi: 'A Blok',
        not: 'WC ayrı olan daireler için', createdAt: '2026-01-15T08:00:00Z', updatedAt: '2026-01-30T09:00:00Z',
    },
];

// Banyo türleri
export const banyoTurleri = [
    { key: 'Klozet', label: 'Klozet', aciklama: 'Asma/yer tipi' },
    { key: 'Lavabo', label: 'Lavabo', aciklama: 'Tezgah altı/üstü' },
    { key: 'Batarya / Armatür', label: 'Batarya / Armatür', aciklama: 'Lavabo/duş bataryası' },
    { key: 'Duş Kabin', label: 'Duş Kabin', aciklama: 'Cam duş kabini' },
    { key: 'Banyo Dolabı', label: 'Banyo Dolabı + Ayna', aciklama: 'Ayna dahil dolap' },
    { key: 'WC Dolabı', label: 'WC Dolabı + Ayna', aciklama: 'Mini lavabo dolabı' },
    { key: 'Aksesuar Seti', label: 'Aksesuar Seti', aciklama: 'Havluluk, sabunluk vb.' },
];

// İstatistikler
export const getBanyoStats = (insaatId) => {
    const filtered = insaatId
        ? banyoSiparisler.filter(s => s.insaatId === insaatId)
        : banyoSiparisler;

    const toplamKalem = filtered.length;
    const teslimEdilen = filtered.filter(s => s.durum === 'teslim').length;
    const montajlanan = filtered.reduce((acc, s) => acc + (s.montajlanan || 0), 0);
    const toplamMaliyet = filtered.reduce((acc, s) => acc + s.toplamFiyat, 0);

    return { toplamKalem, teslimEdilen, montajlanan, toplamMaliyet };
};

// Helper
export const getBanyoByInsaat = (insaatId) => {
    if (!insaatId) return banyoSiparisler;
    return banyoSiparisler.filter(s => s.insaatId === insaatId);
};
